import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdministrationComponent } from './administration/administration.component';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { IDashboardComponent } from './incadea/i-dashboard/i-dashboard.component';
import { ReportsComponent } from './reports/reports.component';
import { SchedulingComponent } from './scheduling/scheduling.component';
import { SettingsComponent } from './settings/settings.component';
import { TemplatesComponent } from './administration/templates/templates.component';
import { WorkshopsComponent } from './administration/workshops/workshops.component';
import { AdvisorsComponent } from './administration/advisors/advisors.component';
import { CustomerBaseComponent } from './administration/Components/customer-base/customer-base.component';
import { BannerManageServiceComponent } from './WebView/Banners/banner-manage-service/banner-manage-service.component';
import { BannerSuccessBookingComponent } from './WebView/Banners/banner-success-booking/banner-success-booking.component'
import { ChooseServiceComponent } from './WebView/FormWebView/diary/choose-service/choose-service.component';


import { ScheduleAppointmentComponent } from './WebView/FormWebView/diary/schedule-appointment/schedule-appointment.component';

import { ConsultantFormComponent } from './WebView/FormWebView/query/consultant-form/consultant-form.component';
import { ChooseServiceWorkshopComponent } from './WebView/FormWebView/diary/choose-service-workshop/choose-service-workshop.component';
import { LoginComponent } from './WebView/login/login.component';
import { IBannerManageServiceComponent } from './incadea/i-web-view/i-banners/i-banner-manage-service/i-banner-manage-service.component';
import { IConsultantAppointmentComponent } from './incadea/i-web-view/i-consultant-appointment/i-consultant-appointment.component';
import { IScheduleChooseComponent } from './incadea/i-web-view/i-schedule-choose/i-schedule-choose.component';
import { ICreateAppointmentComponent } from './incadea/i-web-view/i-create-appointment/i-create-appointment.component';
import { IBannerSuccessBookingComponent } from './incadea/i-web-view/i-banners/i-banner-success-booking/i-banner-success-booking.component';
import { UsersComponent } from './users/users.component';
import { ClientsComponent } from './administration/clients/clients.component';
import { AlertComponent } from './layout/alert/alert.component';
import { ISchedulingComponent } from './incadea/i-scheduling/i-scheduling.component';
import { NotFoundComponent } from './layout/not-found/not-found.component';
import { sessionFailedComponent } from './WebView/login/Components/sessionFailed/sessionFailed.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'scheduling',
    pathMatch: 'full'
  },
  {
    path: 'PingId/Saml/AssertionConsumerService'
  },
  {
    path: 'PingId/Sso/InitiateSingleSignOn'
  },
  {
    path: 'PingId/Saml/SingleLogoutService'
  },
  {
    path: 'PingId/Saml/LogOff'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  
  {
    path: 'sessionFailed',
    component: sessionFailedComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent
  },
  {
    path: 'i-dashboard',
    component: IDashboardComponent
  },
  //WebView
  {
    path: 'WebView/bannerManage/:brand/:country',
    component: BannerManageServiceComponent
  },
  {
    path: 'WebView/bannerManage/:brand/:country/:language',
    component: BannerManageServiceComponent
  },
  {
    path: 'WebView/bannerSuccess/:brand/:country',
    component: BannerSuccessBookingComponent
  },
  {
    path:'WebView/FormWebView/schedule-appointment/:brand/:country',
    component: ScheduleAppointmentComponent
  },
  {
     path:'WebView/FormWebView/choose-service/:brand/:country',
     component: ChooseServiceComponent
  },
  {
    path:'WebView/FormWebView/choose-service-workshop/:brand/:country',
    component:ChooseServiceWorkshopComponent
  },
  {
     path:'WebView/FormWebView/query/consultant-form/consultant-form/:brand/:country',
     component:ConsultantFormComponent
  },

  //webview Incadea
  {
    path:'WebView/i-bannerManage/:brand/:country',
    component:IBannerManageServiceComponent 
 },
 {
  path:'WebView/i-bannerManage/:brand/:country/:language',
  component:IBannerManageServiceComponent 
},
{
  path:'WebView/i-consultant-appointment/:brand/:country',
  component:IConsultantAppointmentComponent 
},
  
  {
    path:'WebView/i-bannerManage/:brand/:country/:onlyInchcapeRetail/:language',
    component:IBannerManageServiceComponent
  },
  {
    path:'WebView/i-schedule-choose/:brand/:country',
    component: IScheduleChooseComponent
  },

  {
    path:'WebView/i-create-appoiment/:brand/:country',
    component: ICreateAppointmentComponent
  },
  {
    path:'WebView/i-bannerSuccess/:brand/:country',
    component: IBannerSuccessBookingComponent
  },
  

  
  {
    path: 'administration',
    // component: AdministrationComponent,
    children: [
      {
        path: 'templates',
        component: TemplatesComponent
      },
      {
        path: 'workshops',
        component: WorkshopsComponent
      },
      {
        path: 'advisors',
        component: AdvisorsComponent
      },
      {
        path: 'users',
        component: UsersComponent
      },
      {
        path: 'clients',
        component: ClientsComponent
      },
    ]
  },
  {
    path: 'scheduling',
    component: SchedulingComponent
  },
  {
    path: 'Ischeduling',
    component: ISchedulingComponent
  },
  {
    path: 'reports',
    component: ReportsComponent
  },
  {
    path: 'settings',
    component: SettingsComponent
  },
  {
    path:'alert',
    component: AlertComponent
  },
  { path: 'WebView/404', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
